export const f_0_5 = '0.5rem'
export const f_0_75 = '0.75rem'
export const f_0_875 = '0.875rem'
export const f_1 = '1rem'
export const f_1_25 = '1.25rem'
export const f_1_5 = '1.5rem'
export const f_2 = '2rem'
export const f_2_5 = '2.5rem'
export const f_3 = '3rem' // 48px
export const f_3_5 = '3.5rem'
export const f_4 = '4rem'
